import Vue from 'vue';
import Vuex from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    stages: [],
    matches: [],
    teams: [],
    players: [],
    loading: false,
    stage: null,
    week: null,
  },
  actions,
  getters,
  mutations,
});
